"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _headerBar = _interopRequireDefault(require("./header-bar"));

var _leftNav = _interopRequireDefault(require("./left-nav"));

var _KeywordSearch = _interopRequireDefault(require("../forms/KeywordSearch"));

var _Modal = _interopRequireDefault(require("../general/Modal"));

var _DeprecationUtils = require("../../util/DeprecationUtils");

var _underscore = _interopRequireDefault(require("underscore"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source))).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class AppFrame
 * @desc This component packages the HeaderBar and LeftNav components and coordinates their navs.
 *
 * @param {string} [data-id="app-frame"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {boolean} [autoSelectItemFromRoot=false]
 *          When true, changing the root will auto-select the first nav item under it.
 * @param {boolean} [autoSelectItemFromSection=false]
 *          When true, opening a section will auto-select the first nav item under it.
 * @param {boolean} [autoSelectSectionFromItem=false]
 *          When true, selecting an item will open the section it's in.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {object} headerBarProps
 *     Props that are passed on to the HeaderBar component. See HeaderBar documentation.
 * @param {object} leftNavBarProps
 *     Props that are passed on to the LeftNavBar component
 * @property {string} [copyrightYear="2003"]
 *     First year of the copyright message. (The second year is always the current year.)
 * @param {LeftNavBar#Section[]} navTree
 *          A prop which describes the structure of the nav tree.  This will be an array of
 *          Section objects, each of which may have an array of Node objects as its children.
 * @param {boolean} [oneSectionOnly=false]
 *          When true, opening a section will close all other sections.
 * @param {AppFrame~onItemChange} [onItemChange]
 *          Handler for when the current item changes. Accepts (itemId, sectionId)
 * @param {AppFrame~onRootChange} [onRootChange]
 *          Handler for when the root changes. Accepts the id for the root branch.
 * @param {AppFrame~onSectionChange} [onSectionChange]
 *          Handler for when a section is toggled. Accepts the id of the section.
 * @param {bool} [searchable]
 *          This is an experimental prop that is not ready for production.
 */

/**
 * @callback AppFrame~onItemChange
 * @param {string|number} id
 *             The id of the item that was clicked
 * @param {string|number} sectionId
 *             The id of the section the item that was clicked belongs to.
 */

/**
 * @callback AppFrame~onRootChange
 * @param {string|number} id
 *             The id of the item that was clicked
 */

/**
 * @callback AppFrame~onSectionChange
 * @param {string|number} id
 *             The id of the item that was clicked
 */
var AppFrame = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AppFrame, _React$Component);

  var _super = _createSuper(AppFrame);

  function AppFrame() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, AppFrame);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchOpen: false
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getNodeIn", function (id, tree) {
      return (0, _reduce.default)(_underscore.default).call(_underscore.default, tree, function (result, branch) {
        if (result) {
          return result;
        }

        if (branch.id === id) {
          return branch;
        }

        if (branch.children) {
          return _this._getNodeIn(id, branch.children);
        }

        return null;
      }, null);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getNode", function (id) {
      return _this._getNodeIn(id, _this.props.navTree);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_isNodeIn", function (id, tree) {
      return _this._getNodeIn(id, tree) ? true : false;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleItemChange", function (id, sectionId) {
      _this.props.onItemChange(id, sectionId);

      if (_this.props.autoSelectSectionFromItem) {
        if (id !== sectionId && !_this.props.leftNavBarProps.openSections[sectionId]) {
          _this._handleSectionChange(sectionId);
        }
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleSectionChange", function (id) {
      if (_this.props.oneSectionOnly) {
        _underscore.default.each(_this.props.leftNavBarProps.openSections, function (value, section) {
          if (_this.props.leftNavBarProps.openSections[section] && section !== id) {
            _this.props.onSectionChange(section);
          }
        });
      }

      var opening = !(_this.props.leftNavBarProps.openSections[id] || false);

      _this.props.onSectionChange(id);

      if ((_this.props.autoSelectItemfromSection || _this.props.autoSelectItemFromSection) && opening) {
        var _this$_getNode = _this._getNode(id),
            children = _this$_getNode.children;

        if (!_this._isNodeIn(_this.props.selectedNode, children)) {
          _this.props.onItemChange(children[0].id, id);
        }
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleRootChange", function (id) {
      _this.props.onRootChange(id);

      if (_this.props.autoSelectItemFromRoot) {
        var rootBranch = (0, _find.default)(_underscore.default).call(_underscore.default, _this.props.navTree, function (branch) {
          return branch.id === id || branch.label === id;
        });
        var section = rootBranch.children[0];

        if (section.children) {
          _this._handleItemChange(section.children[0].id, section.id);
        } else {
          _this._handleItemChange(section.id, section.id);
        }
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onSearchClick", function (_ref) {
      var id = _ref.id,
          root = _ref.root,
          section = _ref.section;
      var _this$props = _this.props,
          openSections = _this$props.leftNavBarProps.openSections,
          onItemChange = _this$props.onItemChange,
          onRootChange = _this$props.onRootChange,
          onSectionChange = _this$props.onSectionChange;

      var openSection = function openSection(sec) {
        var _context2;

        // Close all other open sections except for the selected one
        (0, _forEach.default)(_context2 = (0, _keys.default)(openSections)).call(_context2, function (key) {
          var sectionOpen = openSections[key];

          if (sectionOpen && key !== sec) {
            onSectionChange(key);
          }
        });
        var isOpen = openSections[sec];

        if (!isOpen) {
          onSectionChange(sec);
        }
      };

      onRootChange(root.id || id);

      if (section) {
        openSection(section.id);
      }

      onItemChange(id);

      _this.setState({
        searchOpen: false
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_renderSearchModal", function () {
      if (_this.props.searchable && _this.state.searchOpen) {
        var closeModal = function closeModal() {
          return _this.setState({
            searchOpen: false
          });
        };

        return /*#__PURE__*/_react.default.createElement(_Modal.default, {
          className: "nav-search__modal",
          closeOnBgClick: true,
          expanded: true,
          modalTitle: "Search",
          type: "dialog",
          onClose: closeModal
        }, /*#__PURE__*/_react.default.createElement(_KeywordSearch.default, {
          "data-id": "app-frame-search",
          onResultClick: _this._onSearchClick,
          tree: _this.props.navTree
        }));
      } else {
        return null;
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_buildHeaderProps", function () {
      var _this$props2 = _this.props,
          _this$props2$headerBa = _this$props2.headerBarProps,
          headerBarProps = _this$props2$headerBa === void 0 ? {} : _this$props2$headerBa,
          searchable = _this$props2.searchable;

      if (searchable) {
        var _context3;

        var _headerBarProps$tree = headerBarProps.tree,
            tree = _headerBarProps$tree === void 0 ? {} : _headerBarProps$tree;
        var searchNode = {
          id: "search",
          iconClassName: "icon-search",
          onClick: function onClick() {
            return _this.setState({
              searchOpen: true
            });
          }
        };
        return _objectSpread(_objectSpread({}, _underscore.default.omit(headerBarProps, "openNode")), {}, {
          tree: (0, _concat.default)(_context3 = [searchNode]).call(_context3, tree)
        });
      } else {
        return _underscore.default.omit(_this.props.headerBarProps, "openNode");
      }
    });
    return _this;
  }

  (0, _createClass2.default)(AppFrame, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          copyrightYear = _this$props3.copyrightYear,
          leftNavBarProps = _this$props3.leftNavBarProps,
          navTree = _this$props3.navTree,
          root = _this$props3.root;
      var rootBranch = root ? (0, _filter.default)(navTree).call(navTree, function (_ref2) {
        var id = _ref2.id,
            label = _ref2.label;
        return id === root || label === root;
      })[0] : navTree,
          tree = rootBranch.children || navTree,
          navOptions = rootBranch !== navTree ? (0, _map.default)(_underscore.default).call(_underscore.default, navTree, function (_ref3) {
        var id = _ref3.id,
            label = _ref3.label;
        return {
          id: id,
          label: label
        };
      }) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.className,
        "data-id": this.props["data-id"]
      }, /*#__PURE__*/_react.default.createElement(_headerBar.default, (0, _extends2.default)({}, this._buildHeaderProps(), {
        navOptions: navOptions,
        navSelected: this.props.root,
        onNavChange: this._handleRootChange
      })), /*#__PURE__*/_react.default.createElement(_leftNav.default, (0, _extends2.default)({
        topContent: rootBranch.label,
        copyrightYear: copyrightYear
      }, leftNavBarProps, {
        onSectionValueChange: this._handleSectionChange,
        onItemValueChange: this._handleItemChange,
        tree: tree
      })), this.props.children, this._renderSearchModal());
    }
  }]);
  return AppFrame;
}(_react.default.Component);

(0, _defineProperty3.default)(AppFrame, "propTypes", {
  autoSelectItemFromRoot: _propTypes.default.bool,
  autoSelectItemFromSection: _propTypes.default.bool,
  autoSelectItemfromSection: (0, _DeprecationUtils.deprecatedProp)({
    message: "There was a typo. Please capitalize the F."
  }),
  autoSelectSectionFromItem: _propTypes.default.bool,
  className: _propTypes.default.string,
  headerBarProps: _propTypes.default.object,
  "data-id": _propTypes.default.string,
  leftNavBarProps: _propTypes.default.object,
  oneSectionOnly: _propTypes.default.bool,
  onItemChange: _propTypes.default.func,
  onRootChange: _propTypes.default.func,
  onSectionChange: _propTypes.default.func,
  navTree: _propTypes.default.array.isRequired,
  root: _propTypes.default.string,
  searchable: _propTypes.default.bool,
  copyrightYear: _propTypes.default.string
});
(0, _defineProperty3.default)(AppFrame, "defaultProps", {
  autoSelectItemFromRoot: false,
  autoSelectItemFromSection: false,
  autoSelectSectionFromItem: false,
  "data-id": "app-frame",
  oneSectionOnly: false,
  onItemChange: _underscore.default.noop,
  onRootChange: _underscore.default.noop,
  onSectionChange: _underscore.default.noop,
  openSections: {},
  searchable: false
});
var _default = AppFrame;
exports.default = _default;
module.exports = exports["default"];